var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
// Get component types for a question set with association status
export function getQuestionSetComponentTypes(questionSetId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(`/api/internal/component_question_sets/${questionSetId}/component_types`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching component types for question set:', error);
            return {
                error: {
                    message: 'Failed to fetch component types'
                }
            };
        }
    });
}
// Update component type associations for a question set
export function updateQuestionSetComponentTypes(questionSetId, componentTypeIds) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/component_question_sets/${questionSetId}/update_component_types`, { component_type_ids: componentTypeIds });
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error updating component types for question set:', error);
            return {
                error: {
                    message: 'Failed to update component types'
                }
            };
        }
    });
}
// Export default object with all functions
export default {
    getQuestionSetComponentTypes,
    updateQuestionSetComponentTypes
};
